import { useGridStyles } from "@/pages/laboratory/styles/gridStyles";
import { useContextMenuMESF } from "@dexteel/mesf-core";
import { Button, Grid, Typography } from "@material-ui/core";
import {
	DefaultMenuItem,
	GetContextMenuItemsParams,
	GridApi,
	MenuItemDef,
} from "ag-grid-community";
import { AgGridReact } from "ag-grid-react";
import { useCallback, useEffect, useState } from "react";
import { useCatalogCategoryContext } from "../../context/CategoriesContext";
import { useCategoriesOptionsFunctions } from "../../hooks/useCategoriesOptionsFunctions";
import { useTableData } from "../../hooks/useTableData";
import { CreateCategory } from "./CreateCategory";
import { DeleteCategory } from "./DeleteCategory";
import { EditCategory } from "./EditCategory";
import { Filters } from "./Filters";

type Props = {
	getCatalogCategoriesFromAPI: Function;
	isLoading: boolean;
	setIsLoading: Function;
};

export const TableCategories = ({
	getCatalogCategoriesFromAPI,
	isLoading,
}: Props) => {
	const [showCreateModal, setShowCreateModal] = useState(false);
	const [showEditModal, setShowEditModal] = useState(false);
	const [showDeleteModal, setShowDeleteModal] = useState(false);
	const [categoryId, setCategoryId] = useState<number | null>(null);
	const [gridApi, setGridApi] = useState<GridApi | null>(null);

	const { getMenuOptions } = useCategoriesOptionsFunctions({
		setCategoryId,
		setShowEditModal,
		setShowDeleteModal,
		setShowCreateModal,
	});

	const { showContextMenu, registerConfig } = useContextMenuMESF();
	const { rows, columnDefs, defaultColDef } = useTableData({
		setCategoryId,
		setShowEditModal,
		setShowDeleteModal,
		showContextMenu,
	});

	const {
		state: { assetIdToFilter },
	} = useCatalogCategoryContext();

	const onRowDoubleClicked = (event: any) => {
		setCategoryId(event.data.DelayCategoryId);
		setShowEditModal(true);
	};

	const getContextMenuItems = useCallback(
		(params: GetContextMenuItemsParams): (DefaultMenuItem | MenuItemDef)[] => {
			const data = params.node?.data;
			showContextMenu(event as any, data, "categoriesContext");
			return [];
		},
		[rows],
	);

	useEffect(() => {
		if (isLoading) {
			gridApi?.showLoadingOverlay();
		} else {
			gridApi?.hideOverlay();
		}
	}, [isLoading, rows, gridApi]);

	useEffect(() => {
		registerConfig({
			id: "categoriesContext",
			getOptions: getMenuOptions,
		});
	}, []);

	const classes = useGridStyles();

	return (
		<>
			<Grid item xs={12} container justifyContent="center" spacing={1}>
				<Grid item md={12} xs={12}>
					<Typography variant="h5" style={{ fontWeight: 600 }}>
						Delays Categories
					</Typography>
					<Filters />
				</Grid>

				<Grid
					item
					xs={12}
					container
					justifyContent="flex-end"
					alignContent="center"
				>
					<Grid
						item
						md={12}
						xs={12}
						style={{ height: "68vh" }}
						className={classes.borderAgGridTable}
					>
						<div style={{ height: "100%", width: "100%" }}>
							<AgGridReact
								rowData={rows || []}
								columnDefs={columnDefs}
								getRowId={(params) => params.data.DelayCategoryId}
								animateRows={true}
								rowSelection="single"
								getContextMenuItems={getContextMenuItems}
								onRowDoubleClicked={onRowDoubleClicked}
								onGridReady={(params) => setGridApi(params.api)}
							/>
						</div>
					</Grid>

					<Grid item md={"auto"} xs={12} style={{ marginTop: 10 }}>
						<Button
							variant="contained"
							color="primary"
							fullWidth
							style={{ minWidth: 250 }}
							onClick={() => setShowCreateModal(!showCreateModal)}
						>
							NEW CATEGORY
						</Button>
					</Grid>
				</Grid>
			</Grid>

			<CreateCategory
				show={showCreateModal}
				onHide={(shouldUpdate: boolean) => {
					setShowCreateModal(false);
					if (shouldUpdate) {
						getCatalogCategoriesFromAPI(assetIdToFilter);
					}
				}}
				refreshData={getCatalogCategoriesFromAPI}
			/>
			<EditCategory
				show={showEditModal}
				onHide={(shouldUpdate: boolean) => {
					setShowEditModal(false);
					if (shouldUpdate) {
						getCatalogCategoriesFromAPI(assetIdToFilter);
					}
				}}
				DelayCategoryId={categoryId}
			/>
			<DeleteCategory
				show={showDeleteModal}
				onHide={(shouldUpdate: boolean) => {
					setShowDeleteModal(false);
					if (shouldUpdate) {
						getCatalogCategoriesFromAPI(assetIdToFilter);
					}
				}}
				DelayCategoryId={categoryId}
			/>
		</>
	);
};
